import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireAuth } from '@/core/lib/route-guards'
import { rootRoute } from '@/core/routes'
import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'

import DashboardLayout from '@/modules/dashboard/pages/dashboard-layout.page'

export const dashboardRoute = createRoute({
  path: '/app',
  getParentRoute: () => rootRoute,
  beforeLoad: requireAuth,
  component: DashboardLayout,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const homeRoute = createRoute({
  getParentRoute: () => dashboardRoute,
  path: '/',
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/dashboard/pages/home.page')
  ),
})

export const forbiddenRoute = createRoute({
  getParentRoute: () => dashboardRoute,
  path: '/forbidden',
  head: () => ({
    meta: [{ title: 'Yetkisiz Erişim' }],
  }),
  component: lazyRouteComponent(
    () => import('@/modules/dashboard/pages/forbidden.page')
  ),
})

// Bilinmeyen `/app/*` alt yolları için catch-all → 404. Statik kardeş rotalar
// (`/app/categories` vb.) daha yüksek öncelikli eşleşir; yalnız eşleşmeyenler buraya düşer.
export const dashboardNotFoundRoute = createRoute({
  getParentRoute: () => dashboardRoute,
  path: '$',
  head: () => ({
    meta: [{ title: 'Sayfa Bulunamadı' }],
  }),
  component: lazyRouteComponent(
    () => import('@/core/pages/global-not-found.page')
  ),
})
